import React from "react";
import { FieldError } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import clsx from "clsx";

import { getClassByVariant } from "helpers/getClassByVariant";
import styles from "./style.module.scss";

interface IProps {
  value?: string;
  onChange?: (value: string) => void;
  label?: string | React.ReactNode;
  className?: string;
  inputClass?: string;
  labelClass?: string;
  wrapperClass?: string;
  error?: FieldError;
  isHideError?: boolean;
  disableCountryCode?: boolean;
  placeholder?: string;
  color?: "primary" | "secondary";
  disabled?: boolean;
}

export default function PhoneNumber({
  value,
  onChange,
  label,
  className,
  inputClass,
  labelClass,
  wrapperClass,
  error,
  placeholder = "",
  disableCountryCode = false,
  isHideError = false,
  color = "primary",
  ...props
}: Readonly<IProps>) {
  return (
    <div className={clsx(styles.smartPhoneInputContainer, className)}>
      {label && (
        <label
          className={clsx(
            styles.smartPhoneInputLabel,
            labelClass,
            getClassByVariant(color)?.label
          )}>
          {label}
        </label>
      )}
      <div className={styles.smartPhoneInputWrapper}>
        <PhoneInput
          value={value}
          onChange={onChange}
          disableDropdown
          disableSearchIcon
          disableInitialCountryGuess
          country={"us"}
          onlyCountries={["us"]}
          placeholder={placeholder}
          specialLabel={""}
          disableCountryCode={disableCountryCode}
          inputClass={clsx(
            styles.smartPhoneInput,
            inputClass,
            getClassByVariant(color)?.input,
            !!error && "!border-b-error"
          )}
          containerClass={wrapperClass}
          {...props}
        />
      </div>
      {error && !isHideError && (
        <span className={styles.smartPhoneInputError}>{error.message}</span>
      )}
    </div>
  );
}
